// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2jVsz","header":"PatientBlock_header__1yvEJ","label":"PatientBlock_label__1HMRi","option":"PatientBlock_option__1vU1t"};